import { CanDeactivateFn } from '@angular/router';
import type { ContratoCrearComponent } from './contrato-crear.component';

export const contratoCrearCanDeactivate: CanDeactivateFn<ContratoCrearComponent> = (component) => {
  return component.confirmarSalidaSiDatosPendientes();
};
